var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg15(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 10.15 7.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#666;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_6"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M.22,7.18v-1.04H1.4V1.24l-1.4,.19V.59L1.84,0h.86V6.14h1.18v1.04H.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.49,7.3c-1.12,0-1.91-.33-2.51-1.38l1.08-.57c.33,.68,.77,.89,1.39,.89,.91,0,1.39-.63,1.39-1.49s-.47-1.39-1.3-1.39c-.57,0-.92,.27-1.16,.71l-1.07-.2,.28-3.87h4.06V1.08h-3.1l-.13,1.76h.02c.46-.37,.91-.5,1.45-.5,1.43,0,2.26,.93,2.26,2.4,0,1.61-1.08,2.56-2.66,2.56Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg15);
export default __webpack_public_path__ + "static/media/15.23a6d798ffa0992ce12326ecbd819db5.svg";
export { ForwardRef as ReactComponent };